import {
    FILTER_COMPANY
} from '../actions/types';

const INITIAL_STATE = {
    isFilter: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FILTER_COMPANY:
            return { ...state,isFilter:action.payload};
        default:
       return state;
    }
};
